// src/components/common/LegalFooter.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Link, Stack } from '@mui/material';

/**
 * Legal links bar (Terms of Use / Data Protection Policy) shown alongside
 * the copyright line in page footers, so the institution stays compliant with
 * Moroccan legislation (loi 09-08 on personal data, loi 2-00 on copyright, etc.).
 */
const LegalFooter = ({ sx }) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === 'ar';

  const links = [
    { to: '/terms', labelAr: 'شروط الاستخدام', labelFr: "Conditions d'utilisation" },
    { to: '/donnees-personnelles', labelAr: 'سياسة الخصوصية', labelFr: 'Politique de confidentialité' }
  ];

  return (
    <Box sx={{ mt: 1.5, ...sx }}>
      <Stack
        direction="row"
        spacing={2}
        divider={<Typography color="text.disabled">•</Typography>}
        sx={{ justifyContent: 'center', flexWrap: 'wrap', rowGap: 0.5 }}
      >
        {links.map((link) => (
          <Link
            key={link.to}
            component={RouterLink}
            to={link.to}
            underline="hover"
            color="text.secondary"
            variant="caption"
          >
            {isAr ? link.labelAr : link.labelFr}
          </Link>
        ))}
      </Stack>
    </Box>
  );
};

export default LegalFooter;
